// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"e418f2ba","533":"e80e091b","624":"47fdf56d","685":"c9c45573","696":"3b7c65d8","747":"fd5e1838","998":"a0a27ab6"}[chunkId] + ".chunk.css";
};